import actionTypes from '../constants/action-types';

const clientUploadAsset = (asset, resolve, reject) => ({
  type: actionTypes.CLIENT_UPLOAD_ASSET,
  payload: {
    asset,
    resolve,
    reject,
  },
});

export default clientUploadAsset;
